export default "__VITE_ASSET__CCZcgL8m__"